import API from "@/api";
import { showGlobalLoading } from "@/components/globalLoading";
import {
	SubmitTransactionParams,
	TransactionParams,
} from "@/components/transcationPopup";
import {
	getUserInfoMethod,
	postApiFinanceBalance,
} from "@/redux/reducers/authSlice";
import { AppDispatch, RootState } from "@/redux/store";
import { isDef } from "@/util/validate";
import { Toast } from "antd-mobile";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useCustomTranslation from "./useTranslation";
import { isEmpty, isString } from "lodash";
import { PayChannel } from "@/pages/Game/type";
import useRouter from "./useRouter";

const useWithdraw = (type: 1 | 2, isInit: boolean = true) => {
	const { params: routerParams } = useRouter();
	type = Number(routerParams.type) as 1 | 2;
	const { dataList: appConfig } = useSelector(
		(state: RootState) => state.config
	);
	const { balance, loginState } = useSelector(
		(state: RootState) => state.auth
	);
	const [withdrawReady, setWithdrawReady] = useState(false);
	const { showLoading, hideLoading } = showGlobalLoading();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();

	const payChannel = useRef<PayChannel | null>();
	const [payChannelData, setPayChannelData] = useState<PayChannel[]>([]);
	const [visible, setVisible] = useState(false);

	const prepareWithdraw = async () => {
		try {
			if (!isDef(appConfig?.tax)) throw new Error(t("AppConfigIsEmpty"));
			setWithdrawReady(true);
		} catch (error) {
			console.error("preWithdraw", error);
		} finally {
			hideLoading();
		}
	};

	const submitWithdraw = async (params: SubmitTransactionParams) => {
		try {
			const { amount, remark, address } = params;

			showLoading();
			const result: any = await API.finances.apiFinanceUserCash({
				itemType: type, // 1/游戏账户 2/代理账户
				coin: amount + "",
				remake: remark,
				payCode: payChannel.current?.code,
				address,
			});
			if (result?.code !== 0) {
				throw new Error(t("RequestWithdrawFailed"));
			}

			setWithdrawReady(false);
			dispatch(
				postApiFinanceBalance(type === 1 ? { itemTypes: [1] } : {})
			);
			Toast.show({
				content: t("WithdrawSuccessfully"),
				position: "top",
			});
			console.log("handleWithDrawSuccess");
		} catch (error: any) {
			let errorMsg = error?.message ?? error;
			if (!isString(errorMsg) || isEmpty(errorMsg)) {
				errorMsg = t("WithdrawFailed");
			}
			Toast.show({
				content: errorMsg,
				position: "top",
			});
			console.error("handleWithdrawError", error);
		} finally {
			hideLoading();
		}
	};

	const cancelWithdraw = () => {
		setWithdrawReady(false);
	};

	const withdrawParams: TransactionParams = {
		min: appConfig?.tax.min,
		max: appConfig?.tax.max,
		balance:
			type === 1
				? balance?.[type]
				: balance?.usableBalance -
				  (balance["4"] > 0 ? balance["4"] : 0), //balance?.[type],
		feeRate: appConfig?.tax.tax,
	};

	const loadPayChannel = async () => {
		const response: any = await API.finances.apiPayChannel();
		if (response?.code === 0) {
			const data = response.content.data;
			payChannel.current = data[0];
			setPayChannelData(data);
		}
	};

	const switchPayChannel = (index: number) => {
		if (index >= 0 && index < payChannelData.length) {
			payChannel.current = payChannelData[index];
			setVisible(false);
		} else {
			throw new Error("Invalid index for payChannelData");
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			if (loginState) {
				await dispatch(getUserInfoMethod());
			}
			await loadPayChannel();
		};
		if (isInit) {
			fetchData();
		}
	}, [loginState, isInit]);

	return {
		visible,
		setVisible,
		payChannel: payChannel.current,
		payChannelData,
		prepareWithdraw,
		submitWithdraw,
		cancelWithdraw,
		withdrawReady,
		withdrawParams,
		switchPayChannel,
	};
};

export default useWithdraw;
